<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import ChevronDown from '/svg/chevron-down.svg'

const props = defineProps<{
  title?: string
  tabs: Array<{ title: string; link: string }>
}>()

const route = useRoute()
const isOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)

const activeTab = computed(() => {
  const current = props.tabs.find((tab) => route.path === tab.link)
  return current ?? props.tabs[0]
})

const handleClickOutside = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside))
</script>

<template>
    <div class="w-full">
        <h2 class="text-[22px] text-[#1b325a] mb-7">{{ title ?? 'تنظیمات' }}</h2>

        <div class="flex flex-wrap items-center justify-between gap-4">
            <!-- 👉 Section dropdown -->
            <div ref="dropdownRef" class="relative w-full sm:w-72">
                <button type="button" @click="isOpen = !isOpen"
                    class="flex w-full items-center justify-between gap-3 rounded-xl bg-[#2d5396] px-4 py-2.5 text-sm font-medium text-white shadow-sm">
                    <span class="truncate">{{ activeTab?.title }}</span>
                    <img :src="ChevronDown" width="20" alt="chevron"
                        :class="['transition-transform duration-300', isOpen ? 'rotate-180' : 'rotate-0']" />
                </button>

                <Transition enter-active-class="transition ease-out duration-200"
                    enter-from-class="opacity-0 -translate-y-2" enter-to-class="opacity-100 translate-y-0"
                    leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0"
                    leave-to-class="opacity-0 -translate-y-2">
                    <ul v-if="isOpen"
                        class="absolute start-0 z-30 mt-2 max-h-72 w-full overflow-y-auto rounded-xl border border-[#eaeef5] bg-white py-2 shadow-lg z-[99999]">
                        <li v-for="(tab, index) in tabs" :key="`setting-tab-${index}`">
                            <RouterLink :to="tab.link" @click="isOpen = false"
                                class="flex w-full items-center justify-between px-4 py-2.5 text-sm text-[#1b325a] transition-colors hover:bg-[#f5f7fa]"
                                :class="route.path === tab.link ? 'bg-[#eaeef5] font-medium' : ''">
                                <span>{{ tab.title }}</span>
                            </RouterLink>
                        </li>
                    </ul>
                </Transition>
            </div>

            <!-- 👉 Actions -->
            <div class="flex items-center gap-2">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>
